import axios from 'axios';
import { call, all, put, takeLatest, select } from 'redux-saga/effects';
import { startOfDay, endOfDay, format } from 'date-fns';

import * as clientPositionReportActions from './client-position-report-actions';

import { saveAs } from 'file-saver';

import { GET_LIST_ALL_REQUEST } from './client-position-report-constants';

import notification from '~/services/notification';
import clientPositionReportServices from './client-position-report-service';

import { ISA_ERROR, USER_ROLE } from '~/constants';

import { AppStateType } from '../root-reducer';

import { formatDateTime, formatMessage } from '~/i18n/translate';
import { UserInterface } from '@e3labs/isa-data-dictionary';

let cancel: any;

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
const CancelToken = axios.CancelToken;
export function* getAllClientPositionReportReport({ type, filters }: { type: any; filters?: any }) {
  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });
  try {
    yield put(clientPositionReportActions.setLoadingData(true));

    const { rowsPerPage, page, order, orderBy } = yield select(
      (state: AppStateType) => state.clientPositionReport.list
    );
    const params = {
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      order,
      orderBy,
      clientExternalCode: filters?.clients?.map(client => client.externalCode)?.join(',') ?? '',
      paymentOptions: filters?.paymentOptions?.map(payment => payment?.externalCode)?.join(',') ?? '',
      issueDate: (() => {
        const from = filters?.issueDate?.from ? format(new Date(filters.issueDate.from), 'yyyy-MM-dd') : '';
        if (!from) return undefined;
        const to = filters?.issueDate?.to
          ? format(new Date(filters.issueDate.to), 'yyyy-MM-dd')
          : format(new Date(), 'yyyy-MM-dd');
        return [from, to].join(',');
      })(),
      dueDate: (() => {
        const from = filters?.dueDate?.from ? format(new Date(filters.dueDate.from), 'yyyy-MM-dd') : '';
        if (!from) return undefined;
        const to = filters?.dueDate?.to
          ? format(new Date(filters.dueDate.to), 'yyyy-MM-dd')
          : format(new Date(), 'yyyy-MM-dd');
        return [from, to].join(',');
      })(),
      invoiceNumber: filters?.invoiceNumber
    };

    const [{ data: successClientPositionReports }, { data: count }] = yield all([
      call(clientPositionReportServices.getListSuccessClientPositionReports, {
        ...params
      }),
      call(clientPositionReportServices.getSuccessRowCount, { ...params })
    ]);

    yield put(
      clientPositionReportActions.getAllClientPositionReportsSuccess({
        clientPositionReports: [...successClientPositionReports],

        rowsCount: count?.count || 0
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(clientPositionReportActions.setLoadingData(false));
  }
}

export default all([takeLatest(GET_LIST_ALL_REQUEST, getAllClientPositionReportReport)]);
